module.exports = __webpack_public_path__ + "static/img/reward-h5.01762ca.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/reward-h5.png
// module id = FG0k
// module chunks = 34